import { render, staticRenderFns } from "./joinTogglePremium.vue?vue&type=template&id=05880c08&lang=pug"
import script from "./joinTogglePremium.vue?vue&type=script&lang=js"
export * from "./joinTogglePremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports